// TODO rename
export * as starkCurve from '@scure/starknet';
export * as weierstrass from '@noble/curves/abstract/weierstrass';
